import { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import MultiColumnLayout from '../MultiColumnLayout';

import CardMobileCarousel from './CardMobileCarousel';

let mediaQuery;

export const CardCarousel = ({ data = null, className = '' }) => {
  const [mobile, setMobile] = useState(false);

  const matchMedia = useCallback((breakpoint = mediaQuery) => {
    if (breakpoint.matches) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      mediaQuery = window.matchMedia('(max-width: 1023px)');
      mediaQuery.addListener(matchMedia);
      matchMedia();
    }
    return () => {
      mediaQuery.removeListener(matchMedia);
    };
  }, []);

  return mobile ? (
    <CardMobileCarousel data={data} containerClass={className} />
  ) : (
    <MultiColumnLayout
      data={data}
      componentType="feature-cards"
      containerClass={className}
    />
  );
};

CardCarousel.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]),
  className: PropTypes.string,
};
